const LandingPage = () => import('@landingPage/views/root/LandingPageRoot.vue');
const LandingPageList = () => import('@landingPage/views/list/LandingPageList.vue');
const LandingPageReport = () => import('@landingPage/views/report/LandingPageReport.vue');
const LandingPageSetting = () => import('@landingPage/views/setting/LandingPageSetting.vue');
const LandingPageOnboarding = () =>
    import('@landingPage/views/onboarding/LandingPageOnboarding.vue');
const LandingPageReportDetails = () =>
    import('@landingPage/views/report/LandingPageReportDetails.vue');
const LandingPageReportOverview = () =>
    import('@landingPage/views/report/LandingPageReportOverview.vue');
const LandingPageReportBlockAnalysis = () =>
    import('@landingPage/views/report/LandingPageReportBlockAnalysis.vue');
const LandingPageReportFormSubmission = () =>
    import('@landingPage/views/report/LandingPageReportFormSubmission.vue');
const LandingPageTemplate = () => import('@landingPage/views/template/LandingPageTemplate.vue');

const Member = () => import('@master/views/member/Member.vue');
const LandingPageDomainManagment = () =>
    import('@landingPage/views/domain/LandingPageDomainManagment.vue');
const LandingPageEditor = () => import('@landingPage/views/editor/LandingPageEditor.vue');

import routerService from './landingpage.router.service';

export default [
    {
        path: 'landing_page',
        name: 'LandingPage',
        component: LandingPage,
        redirect: { name: 'LandingPageList' },
        children: [
            {
                path: 'member',
                name: 'Member',
                component: Member
            },
            {
                path: 'onboarding',
                name: 'LandingPageOnboarding',
                beforeEnter: routerService.beforeEnterOnboarding,
                component: LandingPageOnboarding
            },
            {
                path: 'list/:parentId*',
                name: 'LandingPageList',
                beforeEnter: routerService.beforeEnterList,
                component: LandingPageList,
                meta: {
                    titleI18n: 'router_title.landing_page.page_management'
                }
            },
            {
                path: ':pageId',
                name: 'LandingPageReport',
                component: LandingPageReport,
                redirect: { name: 'LandingPageReportOverview' },
                children: [
                    {
                        name: 'LandingPageReportDetails',
                        path: 'details',
                        component: LandingPageReportDetails,
                        meta: {
                            titleI18n: 'router_title.landing_page.page_details'
                        }
                    },
                    {
                        name: 'LandingPageReportOverview',
                        path: 'report',
                        component: LandingPageReportOverview,
                        meta: {
                            hideReportHeaderShadow: true,
                            titleI18n: 'router_title.landing_page.page_report'
                        }
                    },
                    // {
                    //     name: 'LandingPageReportBlockAnalysis',
                    //     path: 'block-analysis',
                    //     component: LandingPageReportBlockAnalysis
                    // },
                    {
                        name: 'LandingPageReportFormSubmission',
                        path: 'form-submission',
                        component: LandingPageReportFormSubmission,
                        meta: {
                            titleI18n: 'router_title.landing_page.page_form_submission'
                        }
                    },
                    {
                        name: 'LandingPageSetting',
                        path: 'setting',
                        component: LandingPageSetting,
                        meta: {
                            hideReportHeader: true,
                            titleI18n: 'router_title.landing_page.page_setting'
                        }
                    },
                    {
                        name: 'LandingPageTemplate',
                        path: 'template',
                        component: LandingPageTemplate,
                        meta: {
                            hideReportHeader: true,
                            titleI18n: 'router_title.landing_page.page_template'
                        }
                    },
                    {
                        name: 'LandingPageEditor',
                        path: 'editor',
                        component: LandingPageEditor,
                        meta: {
                            hideHeader: true,
                            hideReportHeader: true,
                            titleI18n: 'router_title.landing_page.page_editor'
                        }
                    }
                ]
            },
            {
                path: 'domain',
                name: 'LandingPageDomainManagment',
                component: LandingPageDomainManagment,
                meta: {
                    titleI18n: 'router_title.landing_page.page_domain_management'
                }
            }
        ]
    }
];
